import React from 'react';

const CustomerContentPart = ({ children }) => {
  return <div className="px-4 sm:px-6 lg:px-8 py-4 sm:py-6">{children}</div>;
};

export default CustomerContentPart;
